export default __webpack_public_path__ + "static/media/026-rocket launcher.374144ee.svg";